export default "__VITE_ASSET__CJW7PjWN__"